<template> 
   <div class="container-reclef">
 <TopoSlot></TopoSlot>
     <p style="color:#000;font-size:25px;font-weight:700;margin: 65px 50px 25px 50px;">Escolha o modelo de Documento Fiscal Eletrônico que deseja importar.</p>    
    <modal name="cnpj-reclef" :clickToClose="false" >
        <div id="cnpj-reclef">
               <p>Antes de prosseguir, informe o CNPJ da empresa emitente que deseja analisar os Documentos Fiscais Eletrônicos</p>
               <the-mask :mask="['###.###.###-##', '##.###.###/####-##']" v-model="cnpj"/>
               <p style="color: #545454;font-size: 13px;font-weight: 600;" v-if="$store.state.textoRetorno">{{$store.state.textoRetorno}}</p>
               <button @click="continuar">Continuar</button>
        </div>
    </modal> 
        <div class="blocos">
            <blocoInput txt="NF-e ou NFC-e" valor="1" idRadio="1"  style="margin-top:40px;"/>
            <blocoInput txt="CT-e ou CT-e OS" valor="2" idRadio="2"  style="margin-top:60px;"/>
        </div>
        <div style="display: flex; align-items: center; justify-content: center;flex-direction: column;margin-top: 30px;">
            <div class="nota">
                <p>
                    <span style="color: rgb(54, 121, 149);">NOTA:</span>
                    Esta ferramenta considera para fins de cálculo, o ICMS destacado na NF em relação a cada produto individualmente. Não estão sendo consideradas situações específicas, por exemplo a Lei nº 10.485/2002, que prevê redução da base de cálculo de PIS e COFINS, para fabricantes ou importadores de máquinas, implementos e veículos, conforme disposto no § 2º, art. 1º, da referida lei. Neste caso, entendemos que o valor a ser excluído em relação ao ICMS, será o valor proporcional ao valor que foi base de cálculo do PIS e COFINS.
                </p>
            </div>
            <button class="continue-button" @click="continuarFinal">Continuar</button>
        </div>
        <div>
            <button @click="voltarPagina()" style="width: 100%; max-width: 130px;  height: 40px;background: #af3437; color: #fff; font-size: 15px; font-weight: 700;margin-bottom:20px; border-radius: 5px;">Voltar</button>
        </div> 
</div>
     
</template>
    
<script>
import {TheMask} from 'vue-the-mask'
import blocoInput from '../components/blocoInput.vue'
export default {
  components: {TheMask,blocoInput},
    data(){
        return{
            cnpj:'',          
        }
    },
    mounted(){        
         window.scrollTo(0, 0);
        document.querySelector('body').style.overflow = 'hidden'
        this.$modal.show('cnpj-reclef')
    },   
    methods:{  
        voltarPagina (){
            this.$router.push({ name: 'principal' })
        },
        isExceptionCnpj(value) {
    var lstCpfException = new Array(
        '00000000000000',
        '11111111111111',
        '22222222222222',
        '33333333333333',
        '44444444444444',
        '55555555555555',
        '66666666666666',
        '77777777777777',
        '88888888888888',
        '99999999999999'
    )

    return lstCpfException.includes(value)
},

 isValidCnpjNumber(value) {
    if (value == '' || value === undefined || value === null || value.legth < 14)
        return false

    return true
},

 sumCnpjDigit(value, length) {
    var pos = length - 7
    var sumDigit = 0

    for (let i = length; i >= 1; i--) {
        sumDigit += value.charAt(length - i) * pos--
        if (pos < 2)
            pos = 9
    }

    return sumDigit
},

 calculateRestCnpj(value) {
    return value % 11 < 2 ? 0 : 11 - value % 11
},
 isCnpjValid(value) {
    value = value.replace(/\D/g, '')
    value = value.padStart(14, '0')

    if (this.isExceptionCnpj(value))
        return false

    if (!this.isValidCnpjNumber(value))
        return false

    if (
        this.calculateRestCnpj(
            this.sumCnpjDigit(value, 12)
        ) !=
        parseInt(value.substring(12, 13))
    ) {
        return false
    }

    if (
        this.calculateRestCnpj(
            this.sumCnpjDigit(value.substring(0, 13), 13)
        ) !=
        parseInt(value.substring(13, 14))
    ) {
        return false
    }

    return true
}, 
        continuarFinal(){            
             let inputs = document.querySelectorAll('input[name="options"]')
             if(inputs[0].checked || inputs[1].checked){
                 if(inputs[0].checked){
                    this.$store.state.tipoDocumento = 1
                    this.$store.state.cnpj = this.cnpj
                    this.$router.push({name:'importar'})
                }else{
                    this.$store.state.tipoDocumento = 2
                    this.$store.state.cnpj = this.cnpj
                    this.$router.push({name:'regime'})
                }
             }   
                 
        } , 
        continuar(){
            if(this.isCnpjValid(this.cnpj)){
                if(this.cnpj.length >=14){
                    this.$modal.hide('cnpj-reclef')
                    document.querySelector('body').style.overflow = 'auto'
                    this.$store.state.textoRetorno = ''
                }else{
                    this.$store.state.textoRetorno = 'Encontramos um erro em seu CNPJ, Insira novamente!'
                }
            }
        }
    }
    

}
</script>

<style>
.b-table-sticky-header {
    max-height: 570px!important;
}
.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.errosDiv {
    width: 100%;
    height: 100%;
    display: flex;   
    justify-content: space-between; 
    align-items: center;
    flex-direction: column;
}
.nota {
    width: 100%;
    background: #fff3cd;
    border: 1px solid #ffeeba;
    margin: 15px 0;
    max-width: 1150px !important;
}
.nota p {
    margin: 0!important;
    font-size: 15px!important;
    color: #212529!important;
    padding: 10px;
    font-weight: 700!important;
    text-align: justify;
    line-height: 34px;
}
.blocos{
    display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}

.radio-component>input:active+label>.input-box, .radio-component>input:checked+label>.input-box, .radio-component>input:focus+label>.input-box {
    background: #af3437!important;
    background-image: none!important;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
}
.large-bar-radio {
    margin: 0 0 0 20px;
}
.radio-component>input {
    opacity: 0;
    position: absolute;
}
.radio-component>input:checked+label>.input-box>.input-box-circle {
    opacity: 1;
    margin: 22%;
    width: 56%;
    height: 56%;
}
label{
    margin-bottom: 0px;
}
.radio-component>input+label>.input-box>.input-box-circle {
    display: block;
    margin: 50%;
    width: 0;
    height: 0%;
    background: #fff;
    border-radius: 50%;
    opacity: 0;
    transition: width .15s ease-in,height .15s ease-in,margin .15s ease-in;
}
.radio-component>input+label>.input-box {
    display: inline-block;
    border: 1px solid #000;
    border-radius: 50%;
    margin: 0;
    padding: 0;
    width: 1em;
    height: 1em;
    background: #fff;
    overflow: hidden;
    vertical-align: -5%;
    user-select: none;
}

.radio-component>input+label>.input-box {
    border-color: #af3437!important;
    background: #fff!important;
}
.large-bar p{
font-size: 14px;
 margin: 0px 0px 0px 20px; 
 font-weight: 700; 
 color: rgb(56, 56, 56); 
 line-height: 15px;
}
.blocos{
    display: flex;   
    justify-content: center;
}
.large-bar {    
    display: flex;
    align-items: center;  
    justify-content: flex-start;
    min-height: 70px!important;
    max-height: 300px!important;
    height: 100px!important;
    background: #eee;
    max-width: 600px;
    width: 100%;
    border-radius: 5px;   
    transition: all .2s;
    border-left: 10px solid #af3437;
}
#cnpj-reclef{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    padding: 10px;
}
#cnpj-reclef p{
    text-align: center; 
    font-size: 18px; 
    color: rgb(0, 0, 0); 
    font-weight: bold;
    margin-bottom: 0;
}
#cnpj-reclef input{
    border-radius: 10px;
    min-height: 35px;
    border: 1px solid #707070;
    max-width: 380px;
    width: 100%;
    padding-left: 10px;
    font-size: 13px;
}
#cnpj-reclef button{
    width: 100%;
    max-width: 130px;
    height: 40px;
    background: #af3437;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}
.continue-button{
margin-top: 40px;
    width: 150px;
    height: 40px;
    background: #af3437;
    color: #fff;
    font-size: 15px;
    font-style: italic;
    border-radius: 5px;
    margin-bottom:50px;
}
</style>